import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";

const useModal = () => {
  const history = useHistory();

  const showModal = (title, description, type, redirectPath, onConfirm, confirmButtonText = "OK") => {
    Swal.fire({
      title: title,
      html: description,
      icon: type,
      backdrop: true,
      allowOutsideClick: false,
      confirmButtonText: confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed && onConfirm) {
        onConfirm();
      }
      if (result.isConfirmed && redirectPath) {
        history.push(redirectPath);
      }
    });
  };

  return showModal;
};

export default useModal;
